var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "2f75d8179c988615b57c56e67eeaf4a1afad648c"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["disivo@disivo-sro"] = {
  id: "2f75d8179c988615b57c56e67eeaf4a1afad648c"
};